import { useState, useCallback } from 'react'
import useServiceVolumesResources from '../../shared/resources/api/v1/admin/docker/useServiceVolumesResources'

export default function useServiceVolumesState(teamSlug, projectSlug, serviceSlug) {
  const [volumes, setVolumes] = useState([])
  const [loading, setLoading] = useState(true)

  const {
    all,
    create,
    update,
    destroy,
  } = useServiceVolumesResources(teamSlug, projectSlug, serviceSlug)

  const load = useCallback(() => {
    return all()
      .then((response) => setVolumes(response.serviceVolumes || []))
      .catch(() => setVolumes([]))
      .finally(() => setLoading(false))
  }, [all])

  const refresh = useCallback(() => {
    return all()
      .then((response) => setVolumes(response.serviceVolumes || []))
      .catch(() => setVolumes([]))
  }, [all])

  const createVolume = useCallback((data) => {
    return create(data).then(() => refresh())
  }, [create, refresh])

  const updateVolume = useCallback((id, data) => {
    return update(id, data).then(() => refresh())
  }, [update, refresh])

  const destroyVolume = useCallback((id) => {
    return destroy(id).then(() => refresh())
  }, [destroy, refresh])

  return {
    volumes,
    loading,
    load,
    createVolume,
    updateVolume,
    destroyVolume,
  }
}
